import {
  isCloneShortCircuit,
  type WizardFormValues,
} from '@sportninja/common/features/competition/wizard'
import type { WizardStep } from '../WizardContext'
import { competitionWord } from '@sportninja/common/features/competition/wizard'

export type WizardStepDef = {
  key: WizardStep[]
  title: string
  description: string
}

const STEP_CREATE: WizardStepDef = {
  key: ['create'],
  title: 'Create',
  description: 'New or Clone',
}
const STEP_INFO: WizardStepDef = {
  key: ['info'],
  title: 'General Info',
  description: 'Dates & Sport Type',
}
const STEP_STRUCTURE: WizardStepDef = {
  key: ['structure', 'structureDivisions', 'structureConferences'],
  title: 'Structure',
  description: 'Division format',
}
const STEP_JOIN: WizardStepDef = {
  key: ['join'],
  title: 'Join',
  description: 'Participants Onboarding',
}
const STEP_SUMMARY: WizardStepDef = {
  key: ['summary'],
  title: 'Summary',
  description: 'Review & finish',
}

// Only step that depends on tenant i18n — recomputed each call.
const stepType = (): WizardStepDef => ({
  key: ['type'],
  title: 'Format',
  description: `${competitionWord()} format`,
})

export const getWizardSteps = (
  values: WizardFormValues,
  currentStep: WizardStep
): WizardStepDef[] => {
  const isCloneFlow =
    values.creationMethod === 'clone' || currentStep === 'clone'
  if (isCloneFlow) {
    return [
      { key: ['create'], title: 'Create', description: 'New or clone' },
      { key: ['clone'], title: 'Cloning', description: 'Review & finish' },
    ]
  }
  if (isCloneShortCircuit(values)) {
    return [STEP_CREATE, STEP_INFO, stepType(), STEP_SUMMARY]
  }
  // Simple Playoffs (no source) is always a manually-managed bracket — no
  // registration onboarding, so the Join step is skipped.
  if (values.competitionType === 'playoffs_simple') {
    return [STEP_CREATE, STEP_INFO, stepType(), STEP_STRUCTURE, STEP_SUMMARY]
  }
  return [
    STEP_CREATE,
    STEP_INFO,
    stepType(),
    STEP_STRUCTURE,
    STEP_JOIN,
    STEP_SUMMARY,
  ]
}

export const getCurrentStepIndex = (
  steps: WizardStepDef[],
  currentStep: WizardStep
): number => {
  const idx = steps.findIndex((s) => s.key.includes(currentStep))
  return idx < 0 ? 0 : idx
}
